import { SET_SHARE_URL } from 'root/src/client/logic/static/actionIds'

export default payload => ({
	type: SET_SHARE_URL,
	payload,
})
